import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&q=80&w=1920" 
          alt="Luxury Hair Salon Interior" 
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20">
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-brand-accent text-sm md:text-base uppercase tracking-[0.3em] font-semibold mb-6"
        >
          Premium Hair Care
        </motion.p>
        
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-5xl md:text-7xl lg:text-8xl text-white font-serif mb-8 leading-tight"
        >
          Artistry in <br/><span className="italic font-light">Every Strand</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6"
        >
          <button className="w-full sm:w-auto bg-white text-brand-dark px-8 py-4 text-sm uppercase tracking-widest font-semibold hover:bg-brand-accent hover:text-white transition-all duration-300">
            Book Appointment
          </button>
          <button className="w-full sm:w-auto border border-white text-white px-8 py-4 text-sm uppercase tracking-widest font-semibold hover:bg-white/10 transition-all duration-300">
            View Services
          </button>
        </motion.div>
      </div>
    </section>
  );
}